import { render, staticRenderFns } from "./DialogEditTransferFee.vue?vue&type=template&id=26f2c12e&"
import script from "./DialogEditTransferFee.vue?vue&type=script&lang=js&"
export * from "./DialogEditTransferFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports